import { render } from "./delete_district_modal.vue?vue&type=template&id=27f5ed04&scoped=true"
import script from "./delete_district_modal.vue?vue&type=script&lang=js"
export * from "./delete_district_modal.vue?vue&type=script&lang=js"

import "../../../assets/css/modal.css?vue&type=style&index=0&id=27f5ed04&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27f5ed04"]])

export default __exports__